import Table from '@/components/table/components/Table.tsx';
import waitlistApi from '@/features/dashboard/waitlist/api/waitlistApi.ts';
import { waitlistApiQueryKeys } from '@/features/dashboard/waitlist/api/waitlistApi.queryKeys.ts';
import { TaggableType } from '@/features/dashboard/tags/types/TaggableType.ts';
import { waitlistRoute } from '@/features/dashboard/waitlist/routes/waitlistRoute.ts';

const GlobalWaitlistTable = () => {
  const search = waitlistRoute.useSearch();

  return (
    <Table
      listSearch={search}
      queryKey={waitlistApiQueryKeys.all()}
      fetchData={waitlistApi.getGlobalAll}
      fetchTableDef={waitlistApi.getGlobalTableDefinition}
      rowContextMenuItems={[]}
      tagTargetType={TaggableType.WAITLIST_ENTRY}
      title="Lista rezerwowa"
    />
  );
};

export default GlobalWaitlistTable;
